import { Ref, forwardRef } from "react"
import { Form, Formik, FormikProps } from "formik"
import * as yup from "yup"

import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { MAX_ORDER_COMMENT_LENGTH } from "../../../../../../constants/inputValidationDefaults"

import { CreateUpdateWorkgroup, HistoryType } from "../workgroupsTypes"
import { CreateUpdateWorkgroupFormContent } from "./CreateUpdateWorkgroupFormContent"

type CreateUpdateWorkgroupFormProps = Readonly<{
    initialValues?: CreateUpdateWorkgroup | null
    history?: HistoryType
    onSubmit: (formData: CreateUpdateWorkgroup) => void
}>
type FormikRef = Ref<FormikProps<CreateUpdateWorkgroup>>

export const CreateUpdateWorkgroupForm = forwardRef(
    ({ initialValues, history, onSubmit }: CreateUpdateWorkgroupFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const defaultInitialValues: CreateUpdateWorkgroup = {
            name: "",
            description: "",
            calendarEmailAddress: "",
            isActive: true,
        }

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("create-or-edit-company-workgroup-field-is-required")),
            calendarEmailAddress: yup
                .string()
                .email(l10n.getString("create-or-edit-company-workgroup-field-invalid-email")),
            description: yup.string().max(
                MAX_ORDER_COMMENT_LENGTH,
                l10n.getString("create-or-edit-company-workgroup-field-description-max-length", {
                    maxLength: MAX_ORDER_COMMENT_LENGTH,
                }),
            ),
        })

        function handleSubmit(values: CreateUpdateWorkgroup) {
            onSubmit(values)
        }

        return (
            <Formik<CreateUpdateWorkgroup>
                enableReinitialize
                initialValues={initialValues ? initialValues : defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <CreateUpdateWorkgroupFormContent history={history} />
                </Form>
            </Formik>
        )
    },
)
